import { render, staticRenderFns } from "./main.vue?vue&type=template&id=af79f4aa&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af79f4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af79f4aa')) {
      api.createRecord('af79f4aa', component.options)
    } else {
      api.reload('af79f4aa', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=af79f4aa&scoped=true", function () {
      api.rerender('af79f4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/modal-temporarily/main.vue"
export default component.exports